import { JSX } from "react";
import { NetworkIntegrityFilterContainer, NetworkIntegrityFilterProvider } from './filters';
import { NetworkSummaryWidget } from "./widgets/NetworkSummaryWidget";

const NetworkIntegrityPage = (): JSX.Element => {
  return (<div>
    <NetworkIntegrityFilterProvider>
      <NetworkIntegrityFilterContainer />
        <NetworkSummaryWidget key="network-summary-widget" />
    </NetworkIntegrityFilterProvider>
  </div>);
}

export { NetworkIntegrityPage };